export default {
  clientid: process.env.MS_CLIENT_ID,
  redirecturl: process.env.MS_REDIRECT_URL,
  authority: process.env.MS_AUTHORITY,
  graphscopes: ['openid', 'profile', 'User.Read']
}



// WEBPACK FOOTER //
// ./src/services/msal/config.js